export default __webpack_public_path__ + "static/media/food1.83d6aab3.jpg";